// tslint:disable: max-line-length
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CallApiMethodsService } from 'src/app/services/AsynchronousRequestServices/call-api-methods.service';
import { SharedFunctionsService } from 'src/app/services/TemplateServices/shared-functions.service';

import { ErrorStructure } from 'src/app/interfaces/management';
import { AnyValues } from 'src/app/interfaces/undetermined';
import { Alerts } from 'src/app/interfaces/user';

@Injectable({ providedIn: 'root' })
export class NotifyService {

  notified: Subject<Alerts> = new Subject<Alerts>();

  constructor(
    private callApiMethods: CallApiMethodsService,
    private sharedMethods: SharedFunctionsService,
  ) { }

  notify(element: string, timer: number, message: string, service: string, method: string, params: AnyValues) {
    this.callApiMethods.sendAsynchronousRequest(service, method, params, null, false, false).then((data: any[] | ErrorStructure) => {
      // ↓ Verifica que el API no devuelva errores
      if (!((data as ErrorStructure).requestStatus === false)) {
        // ↓ Notifica el usuario
        if ((data as any[]).length > 0) { this.sharedMethods.showAlert(message); this.notified.next({ [element]: true }); }
      } else { M.toast({ html: "Imposible mostrar notificaciones", classes: "background-danger white-text" }); }
    }).finally(() => { setTimeout(() => { this.notify(element, timer, message, service, method, params); }, timer); });
  }

}
